import React, { ReactNode, useState } from "react"
import OutsideClickHandler from "react-outside-click-handler"

import {
  ArrowDownButton,
  Container,
  Dropdown,
  DropDownButton,
  EditIcon,
  Flex,
  SaveButton
} from "./ActionDropdownButton.styled"

import { ReactComponent as DownIcon } from "images/icons/chevron-down.svg"

type Props = {
  title?: string
  children: ReactNode | ReactNode[]
  submitEvent?: () => void
  submitLoading?: boolean
  disabled?: boolean
  iconButton?: boolean
}

export const ActionDropdownButton = ({
  title,
  children,
  submitEvent,
  submitLoading,
  disabled,
  iconButton
}: Props) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false)

  return (
    <Container $iconButton={iconButton}>
      <OutsideClickHandler onOutsideClick={() => setShowDropdown(false)}>
        {submitEvent ? (
          <Flex>
            <SaveButton
              type="button"
              disabled={disabled}
              loading={submitLoading}
              handleClick={submitEvent}
            >
              {title}
            </SaveButton>
            <ArrowDownButton type="button" handleClick={() => setShowDropdown(!showDropdown)}>
              <DownIcon />
            </ArrowDownButton>
          </Flex>
        ) : iconButton ? (
          <EditIcon onClick={() => setShowDropdown(!showDropdown)} />
        ) : (
          <DropDownButton type="button" handleClick={() => setShowDropdown(!showDropdown)}>
            {title} <DownIcon />
          </DropDownButton>
        )}
        {showDropdown && (
          <Dropdown
            onClick={(e) => {
              const el = e.target as HTMLElement
              if (el.closest("li")) {
                setShowDropdown(false)
              }
            }}
          >
            {children}
          </Dropdown>
        )}
      </OutsideClickHandler>
    </Container>
  )
}
